import React from 'react';
import { Link } from 'react-router-dom';
import { PawPrint, CheckCircle2, Phone } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import { Button } from '../components/ui/button';
import { CONTACT } from '../data/mock';
import { cdnImg } from '../utils/cdn';

const ServicePage = ({ title, breadcrumb, heroImage, secondaryImage, intro, highlights, features }) => {
  return (
    <div>
      <PageHeader title={title} breadcrumbs={[{ label: breadcrumb }]} />

      <section className="py-20 lg:py-24">
        <div className="max-w-[1200px] mx-auto px-5 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-14 items-center mb-20">
            <div className={secondaryImage ? 'grid grid-cols-2 gap-3' : ''}>
              <div className={`rounded-3xl overflow-hidden shadow-2xl ${secondaryImage ? 'aspect-[3/4]' : 'aspect-[4/3]'}`}>
                <img src={cdnImg(heroImage, { w: 1000 })} alt={title} loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>
              {secondaryImage && (
                <div className="rounded-3xl overflow-hidden shadow-2xl aspect-[3/4]">
                  <img src={cdnImg(secondaryImage, { w: 800 })} alt={`${title} secondary`} loading="lazy" decoding="async" className="w-full h-full object-cover" />
                </div>
              )}
            </div>
            <div>
              <span className="inline-flex items-center gap-2 text-[#e870b6] font-semibold tracking-[0.2em] text-[13px] uppercase mb-3">
                <PawPrint size={16} /> {breadcrumb}
              </span>
              <h2 className="font-serif text-[36px] lg:text-[44px] font-extrabold text-[#1a0b3d] mb-5 leading-tight">
                {title}
              </h2>
              <p className="text-slate-600 leading-relaxed mb-6">{intro}</p>
              <ul className="space-y-3 mb-8">
                {highlights.map((h) => (
                  <li key={h} className="flex items-start gap-3">
                    <CheckCircle2 className="w-5 h-5 text-[#5b3eb5] mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">{h}</span>
                  </li>
                ))}
              </ul>
              <div className="flex flex-wrap gap-3">
                <Link to="/about">
                  <Button className="rounded-full bg-[#5b3eb5] hover:bg-[#4a31a3] text-white px-7 py-6 h-auto gap-2">
                    <PawPrint size={16} /> Book Now
                  </Button>
                </Link>
                <a href={`tel:${CONTACT.phoneRaw}`}>
                  <Button variant="outline" className="rounded-full border-[#5b3eb5] text-[#5b3eb5] hover:bg-[#5b3eb5] hover:text-white px-7 py-6 h-auto gap-2">
                    <Phone size={16} /> {CONTACT.phone}
                  </Button>
                </a>
              </div>
            </div>
          </div>

          {/* Features */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="bg-white rounded-2xl p-7 border border-[#f3d6f5]/50 shadow-md hover:shadow-2xl transition-all hover:-translate-y-1">
                <div className="w-12 h-12 rounded-full bg-[#f3d6f5] flex items-center justify-center mb-4 font-bold text-[#5b3eb5]">
                  {String(i + 1).padStart(2, '0')}
                </div>
                <h3 className="font-serif text-[20px] font-bold text-[#1a0b3d] mb-2">{f.title}</h3>
                <p className="text-slate-600 text-[14px] leading-relaxed">{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicePage;
